// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"_1GTSsh","alwaysInline":"_1msuJH","fullWidthPhablet":"_2cx-XY","stretchHeight":"_2xeZTV","pageSection":"_2IlHn7"};